import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

const HelpApi = ApiCore(globalDomains.HELP_API_AFREECATV);
export default HelpApi;
